type HtmlViewerProps = {
  src: string
  onError?: (error?: any) => void
}

export default function HtmlViewer({ src, onError }: HtmlViewerProps) {
  return <iframe className="w-screen h-screen border-none" src={src} sandbox="allow-same-origin" onError={onError} />
}
